import { RigidBody } from "@react-three/rapier"
import { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { playerStore } from "../../../../store/player.store"
import { observer } from "mobx-react"

const StartPre = observer(({model}) => {
  const dorRef = useRef()


  useEffect(() => {
    if (!playerStore.isPlayerClick) return
    gsap.timeline()
      .to(dorRef.current.rotation, { y: -1.4, duration: 1 })

    setTimeout(() => {
      gsap.timeline()
        .to(dorRef.current.rotation, { y: 0, duration: 1 })
    }, 1600)
  }, [playerStore.isPlayerClick])

  return (
    <>
      <RigidBody type="fixed" colliders="trimesh">
        <primitive object={model.nodes["pre_ground"]} />
      </RigidBody>
      <primitive
        ref={dorRef}
        object={model.nodes["start_door"]}
      />
      <primitive object={model.nodes["pre_box"]} />
    </>
  )
})

export {
  StartPre
}